<template>
  <div class="app-container">
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待检验产品" name="toCheck">
        <to-check-list ref="toCheckList" @tabChange="tabChange">
           <!-- <template slot="toolbar-right">
            <el-button type="primary" @click="openEdit">批量质检</el-button>
          </template> -->
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="160">
                <template slot-scope="{row}">
                    <!-- <el-button v-if="$permission.canWrite()" type="text" @click.stop="lineEdit(row)">质检</el-button> -->
                    <el-button v-if="$permission.canWrite()" type="text" @click.stop="lineEdit2(row)">质检</el-button>
                </template>
            </el-table-column>
          </template>
        </to-check-list>
      </el-tab-pane>
      <el-tab-pane label="检验日志" name="checkLog">
        <check-log-list ref="checkLogList" >
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="160">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canWrite()" type="text" @click="detail(row)">查看</el-button>
                </template>
            </el-table-column>
          </template>
        </check-log-list>
      </el-tab-pane>
    </el-tabs>
    <check-dialog ref="editDialog" @saved="saved" :displayMode="displayMode"></check-dialog>
    <check-new-dialog ref="checkNewDialog" @saved="saved" :displayMode="displayMode"></check-new-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import toCheckList from "@/components/production/reportmanagement/qualityinspection/toCheck/list";
import checkLogList from "@/components/production/reportmanagement/qualityinspection/checkLog/list";

import checkDialog from "@/components/production/reportmanagement/qualityinspection/toCheck/checkDialog";

import checkNewDialog from "@/components/production/reportmanagement/qualityinspection/toCheck/checkDialog2";

export default {
  name: "qualitycheck",
  mixins: [curdMixins],
  components: {
    toCheckList,
    checkLogList,
    checkDialog,
    checkNewDialog
  },
  data() {
    return {
      api: require("@/api/pr/test").default,
      tabName: "toCheck",
      logTab: "0",
      displayMode: 1
    };
  },
  methods: {
    openEdit() {
      const checkList = this.$refs.toCheckList.checkList
      if (checkList.length > 0) {
          this.edit({checkList: checkList, batch: true})
        } else {
          this.$message.error('请勾选列表中的数据！');
        }
    },
    lineEdit(row) {
      this.edit({row: row, batch: false})
    },
    lineEdit2(row) {
      //this.edit({row: row, batch: false})
      this.$refs.checkNewDialog.openEdit({row: row, batch: false});
    },
    handleClick() {
      this.reload();
    },
    detail(row){
      // console.log(row);
      const number = this.$refs.checkLogList.tabName;
      if(number==0){
        this.$refs.checkLogList.$refs['details0Dialog'].openEditById(row.TestId);
      }else{
        this.$refs.checkLogList.$refs['details1Dialog'].openEditById(row.TestId);
      }
        
    },
    logClick() {
      console.log("logClick", this.logTab);
    },
    reload() {
      this.$refs[this.tabName + "List"].reload();
      this.$nextTick(() => {
        this.$refs[this.tabName + "List"].$refs.list.$refs.table.doLayout();
      });
    },
    // 用于刷新页面
    saved() {
      this.reload();
      // this.$refs.toCheckList.$refs.list.query();
    },
    tabChange (val) {
      if (val == '0') this.displayMode = 1;
      else this.displayMode = 2;
    }
  },
};
</script>